import React from 'react';
import styles from './styles.module.scss';
import cx from 'classnames';
import {MarkerIcon} from './MarkerIcon';

type Props = {
    componentClasses?: string;
    pathProps?: React.SVGProps<SVGPathElement>;
    isEmpty?: boolean;
    innerComp?: React.ReactNode;
};

export const MarkerIconWithWrapper = ({innerComp, pathProps, componentClasses, isEmpty}: Props) => {
    return (
        <div className={cx(styles.markerSvg, componentClasses)}>
            <MarkerIcon pathProps={pathProps} isEmpty={isEmpty} />
            {innerComp}
        </div>
    );
};
